let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8U52D"), load("bEOWq"), load("aIlQC"), load("6rkIt")]).then(() => parcelRequire('j2LbL'));